import { DataLayer, calcPrice } from '@grandvisionhq/analytics';

const pushAddFromMiniCartEvent = (sku, name, brand, category, price, discountedPrice, cartId)=>{
    DataLayer.pushEvent({
        event: 'mini_cart_click',
        site_feature: 'mini_cart',
        interaction_type: 'add_to_cart_click',
        items: [
            {
                item_id: sku,
                item_name: name,
                item_brand: brand,
                item_category: category,
                price: calcPrice(discountedPrice),
                metric140: calcPrice(price),
                cart_id: cartId !== null && cartId !== void 0 ? cartId : ''
            }, 
        ]
    });
};

export { pushAddFromMiniCartEvent };
//# sourceMappingURL=data-layer.js.map
